import React, { useEffect, useState } from "react";
import { Star, ExternalLink } from "lucide-react";
import api from "../lib/api";

const GoogleGlyph = ({ size = 16 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
    <path fill="#4285F4" d="M22.5 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.07 5.07 0 0 1-2.2 3.33v2.76h3.56c2.08-1.92 3.22-4.74 3.22-8.1Z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.65l-3.56-2.76c-.99.66-2.25 1.05-3.72 1.05-2.86 0-5.28-1.93-6.15-4.52H2.18v2.84A11 11 0 0 0 12 23Z" />
    <path fill="#FBBC05" d="M5.85 14.12A6.6 6.6 0 0 1 5.5 12c0-.74.13-1.45.35-2.12V7.04H2.18A11 11 0 0 0 1 12c0 1.77.42 3.44 1.18 4.96l3.67-2.84Z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.07.56 4.21 1.65l3.15-3.15C17.46 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.04l3.67 2.84C6.72 7.31 9.14 5.38 12 5.38Z" />
  </svg>
);

const GoogleReviewsBadge = ({ className = "" }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    let mounted = true;
    api.get("/google-reviews")
      .then((res) => { if (mounted) setData(res.data); })
      .catch(() => { if (mounted) setData(null); });
    return () => { mounted = false; };
  }, []);

  if (!data) return null;
  const { rating, total, place_url } = data;

  return (
    <a
      href={place_url}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-3 px-4 py-2 rounded-full bg-white border border-slate-200 shadow-sm hover:border-brand/40 hover:shadow-[0_8px_24px_rgba(255,47,125,0.12)] transition-all duration-300 group ${className}`}
      data-testid="hero-google-badge"
    >
      <GoogleGlyph size={18} />
      <span className="font-heading font-black text-navy-900 tabular-nums">{Number(rating).toFixed(1)}</span>
      <span className="flex items-center gap-0.5">
        {Array.from({ length: 5 }).map((_, i) => (
          <Star
            key={i}
            size={13}
            className={i < Math.round(rating) ? "text-yellow-500 fill-yellow-500" : "text-slate-300"}
            strokeWidth={1.5}
          />
        ))}
      </span>
      <span className="hidden sm:inline text-sm text-slate-600">
        {total} Google reviews
      </span>
      <ExternalLink size={13} className="text-slate-400 group-hover:text-brand transition-colors" />
    </a>
  );
};

export default GoogleReviewsBadge;
